/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/18/20
 *
 */
import {Type} from "class-transformer"
import BaseObject from "@shared/BaseObject";
import DriveStorageAddon from "@shared/Subscription/Addons/DriveStorageAddon";

export default class SubscriptionAddons extends BaseObject {

	@Type(() => DriveStorageAddon)
	driveStorageAddons: DriveStorageAddon[] = []

}
